const bingMapKeyList = [
    'AqypqhBU1MnZIiU_XVWInAbv_I_1B1O9kk9BAFNs8Yi-9KhTz0Q2VIqSw0BYJynz',
    'AsZJAEDeffh-VkmdxQbd21Y3N2GcutEOboC93t0oSUfai8clTD8x_AVsIWU4KCrn',
    'Ame2LX28SuF_rjpVmAOheEtzEYzjZdef-Mx00JLftWpMGtR0d9ABPIhkPFvlI5F4',
    'Auqe9COlNayXnVGKIHz5zTOD0PjJu65IvMkcAmgbPNZNJYJeV9dRhrgp8yL8BwFh',
    'Ahke0ji2GakTmIKn9-IZsonHCvqwyF9A19Dursm-huxaElK9BHuy3V50070Cuvj_',
    'AkNDDyoVYzCii9Ns1qlFp3i71XfYGibopCPOHStN8EApHUQb90sB0_iBEak0yBPv'  
];

module.exports = bingMapKeyList[Math.floor(Math.random() * bingMapKeyList.length)];